export default __webpack_public_path__ + "static/media/Fact_Sheet.b669aa50.pdf";